import Vue from 'vue';
import Vuex from 'vuex';
import Auth from './modules/auth';
import Leads from './modules/leads';
import Categories from './modules/categories';
import Tags from './modules/tags';
import Networks from './modules/networks';
import Users from './modules/users';
import Operations from './modules/operations';
import Connections from './modules/connections';
import Tasks from './modules/tasks';
import Attachments from './modules/attachments';
import Config from './modules/config';
import Rules from './modules/rules';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },

  modules: {
    auth: Auth,
    leads: Leads,
    categories: Categories,
    tags: Tags,
    networks: Networks,
    users: Users,
    operations: Operations,
    connections: Connections,
    tasks: Tasks,
    attachments: Attachments,
    config: Config,
    rules: Rules,
  },
});
